var _path, _circle, _circle2, _path2, _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAirConditioningBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80,80c-44,0-80,36-80,80v560c0,44,36,80,80,80h920c44,0,80-36,80-80V160c0-44-36-80-80-80H80z  M80,190h920v520H80V190z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 360,
    cy: 450,
    r: 190,
    fill: "none",
    stroke: "black",
    strokeWidth: 30
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 360,
    cy: 450,
    r: 28
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M360,450L360,260 M360,450L360,640 M360,450L170,450 M360,450L550,450 M360,450L226,316 M360,450L494,584 M360,450L494,316 M360,450L226,584",
    fill: "none",
    stroke: "black",
    strokeWidth: 24
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 270,
    width: 310,
    height: 40,
    rx: 14
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 375,
    width: 310,
    height: 40,
    rx: 14
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 480,
    width: 310,
    height: 40,
    rx: 14
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 585,
    width: 310,
    height: 40,
    rx: 14
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirConditioningBlack);
export default __webpack_public_path__ + "static/media/air-conditioning-black.9cbaf455c1e60c9315351425edd2f53c.svg";
export { ForwardRef as ReactComponent };